<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <h1 class="ob-page-title mb-4">Property Management</h1>
      <section>
        <div
          class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-3 mb-4 obrame-action-row">
          <div class="btn-toolbar mb-2 mb-md-0">
            <div class="btn-group me-2">
              <button type="button" class="btn btn-obrame-secondary">
                <fa-icon [icon]="faBorderAll" [fixedWidth]="true" class="fixed"></fa-icon> Grid View
              </button>
              <!-- <button type="button" class="btn btn-obrame-secondary">
              <fa-icon [icon]="faTableList" [fixedWidth]="true" class="fixed"></fa-icon> List View
            </button> -->
          </div>
        </div>
        <a class="btn btn-primary btn-obrame-primary" [routerLink]='["property"]'>
          <fa-icon [icon]="faHouseMedical" class="px-2"></fa-icon>
          Add Property
        </a>
      </div>
    </section>
    <section>
      @if (propertiesModel) {
        <div class="row row-cols-1 row-cols-md-3 g-4">
          @for (model of propertiesModel; track model) {
            <div class="col">
              <a [routerLink]='["property", model.id]' class="text-decoration-none">
                <div class="card obrame-card h-100">
                  <div class="card-body">
                    <h5 class="ob-card-title mb-4">{{model.title}}</h5>
                    <div class="ob-card-detail-row">
                      <div class="ob-card-icon ob-card-icon--primary">
                        <fa-icon [icon]="faLocationDot" [fixedWidth]="true"></fa-icon>
                      </div>
                      <div class="ob-card-detail-text">
                        <span class="ob-card-detail-label">Address</span>
                        <span class="ob-card-detail-value">{{model.addressTitle}}</span>
                      </div>
                    </div>
                    <div class="ob-card-detail-row">
                      <div class="ob-card-icon ob-card-icon--info">
                        <fa-icon [icon]="faHouse" [fixedWidth]="true"></fa-icon>
                      </div>
                      <div class="ob-card-detail-text">
                        <span class="ob-card-detail-label">Unit</span>
                        <span class="ob-card-detail-value">{{model.houseNumber}}</span>
                      </div>
                    </div>
                    <div class="ob-card-detail-row">
                      <div class="ob-card-icon ob-card-icon--warning">
                        <fa-icon [icon]="faSquare" [fixedWidth]="true"></fa-icon>
                      </div>
                      <div class="ob-card-detail-text">
                        <span class="ob-card-detail-label">Size</span>
                        <span class="ob-card-detail-value">{{model.houseSize}} {{model.houseSizeUnit}}</span>
                      </div>
                    </div>
                    <div class="ob-card-detail-row">
                      <div class="ob-card-icon ob-card-icon--success">
                        <fa-icon [icon]="faBed" [fixedWidth]="true"></fa-icon>
                      </div>
                      <div class="ob-card-detail-text">
                        <span class="ob-card-detail-label">Rooms</span>
                        <span class="ob-card-detail-value">{{model.numberOfRooms}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
          </div>
        }
      </div>
    }
  </section>
</div>
</div>
</div>